import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FadeIn } from '../components/ui/FadeIn';
export function TermsOfUsePage() {
  return <main className="min-h-screen w-full bg-white selection:bg-neutral-900 selection:text-white pt-24" data-id="element-255">
      <Navbar data-id="element-256" />

      <section className="px-6 py-12 md:py-20" data-id="element-257">
        <div className="max-w-3xl mx-auto" data-id="element-258">
          <FadeIn data-id="element-259">
            <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-neutral-900 mb-12" data-id="element-260">
              Terms of Use
            </h1>

            <div className="space-y-10 text-neutral-600 leading-relaxed" data-id="element-261">
              <div data-id="element-262">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-263">
                  Overview
                </h2>
                <p data-id="element-264">
                  These Terms of Use govern your access to and use of the
                  services provided by Stasis Group PTY LTD ("Stasis Group",
                  "we", "us", or "our"). By engaging our services, you agree to
                  be bound by these terms.
                </p>
              </div>

              <div data-id="element-265">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-266">
                  Services
                </h2>
                <p data-id="element-267">
                  Stasis Group provides custom software development services
                  including MVP development, landing pages, dashboards, workflow
                  automation, and product prototypes. All projects are scoped
                  individually and delivered in milestones with clear
                  deliverables.
                </p>
              </div>

              <div data-id="element-268">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-269">
                  Intellectual Property
                </h2>
                <p data-id="element-270">
                  Upon full payment for each milestone, intellectual property
                  rights for the delivered work transfer to the client. Until
                  payment is received, all work remains the property of Stasis
                  Group PTY LTD.
                </p>
              </div>

              <div data-id="element-271">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-272">
                  Client Responsibilities
                </h2>
                <p data-id="element-273">
                  Clients are responsible for providing accurate project
                  requirements, timely feedback during milestone reviews, and
                  prompt payment as per the agreed schedule.
                </p>
              </div>

              <div data-id="element-274">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-275">
                  Limitation of Liability
                </h2>
                <p data-id="element-276">
                  Stasis Group shall not be liable for any indirect, incidental,
                  or consequential damages arising from the use of our services.
                  Our total liability is limited to the amount paid for the
                  specific milestone in question.
                </p>
              </div>

              <div data-id="element-277">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-278">
                  Governing Law
                </h2>
                <p data-id="element-279">
                  These terms are governed by the laws of the Republic of South
                  Africa. Any disputes shall be resolved in the courts of
                  Johannesburg, Gauteng.
                </p>
              </div>

              <div className="pt-6 border-t border-neutral-100 text-sm text-neutral-400" data-id="element-280">
                <p data-id="element-281">Last updated: February 2026</p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      <Footer data-id="element-282" />
    </main>;
}